import { useState } from "react";
import { MeterBar } from "../../components/MeterBar.js";
import { formatProgressMessage } from "../../domain/resolution/messages.js";

const SAMPLES = [1, 3, 5, 10, 14] as const;
const START_PROGRESS = 6;
const REQUIRED_PROGRESS = 24;

export function ProgressFxLab() {
  const [gain, setGain] = useState<(typeof SAMPLES)[number]>(14);
  const [replay, setReplay] = useState(0);
  const progress = Math.min(REQUIRED_PROGRESS, START_PROGRESS + gain);

  function play(nextGain: (typeof SAMPLES)[number]) {
    setGain(nextGain);
    setReplay((count) => count + 1);
  }

  return (
    <main className="progress-fx-lab">
      <header>
        <p>開発用・非公開</p>
        <h1>進捗演出テスト</h1>
        <span>ボタンを押すたびに演出を再生します。</span>
      </header>

      <section className="progress-fx-lab-card" aria-label="進捗メーターの演出プレビュー">
        <div className="progress-fx-lab-label">
          <span>進捗</span>
          <b>{progress} / {REQUIRED_PROGRESS}</b>
        </div>
        <MeterBar
          key={replay}
          value={progress}
          max={REQUIRED_PROGRESS}
          from={START_PROGRESS}
          glitterGain={gain}
        />
        <p className="progress-fx-lab-copy">{formatProgressMessage(gain)}</p>
      </section>

      <section className="progress-fx-lab-controls" aria-label="進捗量を選ぶ">
        {SAMPLES.map((sample) => (
          <button
            type="button"
            key={sample}
            className={sample === gain ? "is-active" : undefined}
            onClick={() => play(sample)}
          >
            +{sample}
          </button>
        ))}
      </section>
    </main>
  );
}
